module.exports = __webpack_public_path__ + "static/media/lb.5165db9f.svg";